import { ServicesHero } from '@/components/services/ServicesHero'
import { ServicesFeatured } from '@/components/services/ServicesFeatured'
import { ServicesPricing } from '@/components/services/ServicesPricing'

export const ServicesPage = () => (
  <>
    <ServicesHero />
    <ServicesPricing />
    <ServicesFeatured />
  </>
)
